export type RefundStatus = 0 | 1 | 2;
export type RefundRejectReason = 0 | 1 | 2;

export interface RefundRequest {
  id: string;
  merchantId: string;
  cardNumber: string;
  amount: number;
  status: RefundStatus;
  createdAt: string;
  /** ERC-20 this refund settles in; the backend already returns both. */
  settlementToken?: string;
  settlementTokenSymbol?: string;
}

export interface SettleRefundPayload {
  requestId: string;
  merchantId: string;
  cardNumber: string;
}

export interface RejectRefundPayload {
  requestId: string;
  merchantId: string;
  cardNumber: string;
  reason: RefundRejectReason;
}

export const REFUND_STATUS: Record<RefundStatus, string> = {
  0: "Pending",
  1: "Approved",
  2: "Rejected",
};

export enum REFUND_STATUS_CODE {
  PENDING = 0,
  APPROVED = 1,
  REJECTED = 2,
}
export enum REFUND_STATUS_LABEL {
  PENDING = "Pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}
